/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      country
      firstName
      middleName
      lastName
      secondLastName
      email
      phone
      fullAddress
      phones
      avatar
      photos
      idType
      idNumber
      preference {
        id
        dashboardLanguage
        emailsLanguage
        supportLanguage
        subscribedToCompanyNews
        subscribedToTradingNews
        createdAt
        updatedAt
      }
      selectedAccount {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      accounts {
        items {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        nextToken
      }
      transactions {
        items {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      country
      firstName
      middleName
      lastName
      secondLastName
      email
      phone
      fullAddress
      phones
      avatar
      photos
      idType
      idNumber
      preference {
        id
        dashboardLanguage
        emailsLanguage
        supportLanguage
        subscribedToCompanyNews
        subscribedToTradingNews
        createdAt
        updatedAt
      }
      selectedAccount {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      accounts {
        items {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        nextToken
      }
      transactions {
        items {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      country
      firstName
      middleName
      lastName
      secondLastName
      email
      phone
      fullAddress
      phones
      avatar
      photos
      idType
      idNumber
      preference {
        id
        dashboardLanguage
        emailsLanguage
        supportLanguage
        subscribedToCompanyNews
        subscribedToTradingNews
        createdAt
        updatedAt
      }
      selectedAccount {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      accounts {
        items {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        nextToken
      }
      transactions {
        items {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createPreference = /* GraphQL */ `
  mutation CreatePreference(
    $input: CreatePreferenceInput!
    $condition: ModelPreferenceConditionInput
  ) {
    createPreference(input: $input, condition: $condition) {
      id
      dashboardLanguage
      emailsLanguage
      supportLanguage
      subscribedToCompanyNews
      subscribedToTradingNews
      createdAt
      updatedAt
    }
  }
`;
export const updatePreference = /* GraphQL */ `
  mutation UpdatePreference(
    $input: UpdatePreferenceInput!
    $condition: ModelPreferenceConditionInput
  ) {
    updatePreference(input: $input, condition: $condition) {
      id
      dashboardLanguage
      emailsLanguage
      supportLanguage
      subscribedToCompanyNews
      subscribedToTradingNews
      createdAt
      updatedAt
    }
  }
`;
export const deletePreference = /* GraphQL */ `
  mutation DeletePreference(
    $input: DeletePreferenceInput!
    $condition: ModelPreferenceConditionInput
  ) {
    deletePreference(input: $input, condition: $condition) {
      id
      dashboardLanguage
      emailsLanguage
      supportLanguage
      subscribedToCompanyNews
      subscribedToTradingNews
      createdAt
      updatedAt
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      id
      userID
      createdAt
      updatedAt
      name
      number
      type
      status
      currency
      username
      balance
      equity
      margin
      freeMargin
      marginLevel
      transactions {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      userID
      createdAt
      updatedAt
      name
      number
      type
      status
      currency
      username
      balance
      equity
      margin
      freeMargin
      marginLevel
      transactions {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      id
      userID
      createdAt
      updatedAt
      name
      number
      type
      status
      currency
      username
      balance
      equity
      margin
      freeMargin
      marginLevel
      transactions {
        items {
          id
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createAccountTransactions = /* GraphQL */ `
  mutation CreateAccountTransactions(
    $input: CreateAccountTransactionsInput!
    $condition: ModelAccountTransactionsConditionInput
  ) {
    createAccountTransactions(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      account {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAccountTransactions = /* GraphQL */ `
  mutation UpdateAccountTransactions(
    $input: UpdateAccountTransactionsInput!
    $condition: ModelAccountTransactionsConditionInput
  ) {
    updateAccountTransactions(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      account {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAccountTransactions = /* GraphQL */ `
  mutation DeleteAccountTransactions(
    $input: DeleteAccountTransactionsInput!
    $condition: ModelAccountTransactionsConditionInput
  ) {
    deleteAccountTransactions(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      account {
        id
        userID
        createdAt
        updatedAt
        name
        number
        type
        status
        currency
        username
        balance
        equity
        margin
        freeMargin
        marginLevel
        transactions {
          nextToken
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTransaction = /* GraphQL */ `
  mutation CreateTransaction(
    $input: CreateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    createTransaction(input: $input, condition: $condition) {
      id
      userID
      type
      status
      currency
      sourceAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      targetAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      methodName
      methodTransactionID
      value
      createdAt
      updatedAt
      persisted
      history {
        items {
          id
          createdAt
          status
          resourceType
          resourceID
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateTransaction = /* GraphQL */ `
  mutation UpdateTransaction(
    $input: UpdateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    updateTransaction(input: $input, condition: $condition) {
      id
      userID
      type
      status
      currency
      sourceAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      targetAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      methodName
      methodTransactionID
      value
      createdAt
      updatedAt
      persisted
      history {
        items {
          id
          createdAt
          status
          resourceType
          resourceID
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteTransaction = /* GraphQL */ `
  mutation DeleteTransaction(
    $input: DeleteTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    deleteTransaction(input: $input, condition: $condition) {
      id
      userID
      type
      status
      currency
      sourceAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      targetAccount {
        id
        transaction {
          id
          userID
          type
          status
          currency
          methodName
          methodTransactionID
          value
          createdAt
          updatedAt
          persisted
        }
        account {
          id
          userID
          createdAt
          updatedAt
          name
          number
          type
          status
          currency
          username
          balance
          equity
          margin
          freeMargin
          marginLevel
        }
        createdAt
        updatedAt
      }
      methodName
      methodTransactionID
      value
      createdAt
      updatedAt
      persisted
      history {
        items {
          id
          createdAt
          status
          resourceType
          resourceID
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createTransactionHistory = /* GraphQL */ `
  mutation CreateTransactionHistory(
    $input: CreateTransactionHistoryInput!
    $condition: ModelTransactionHistoryConditionInput
  ) {
    createTransactionHistory(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      createdAt
      status
      resourceType
      resourceID
      updatedAt
    }
  }
`;
export const updateTransactionHistory = /* GraphQL */ `
  mutation UpdateTransactionHistory(
    $input: UpdateTransactionHistoryInput!
    $condition: ModelTransactionHistoryConditionInput
  ) {
    updateTransactionHistory(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      createdAt
      status
      resourceType
      resourceID
      updatedAt
    }
  }
`;
export const deleteTransactionHistory = /* GraphQL */ `
  mutation DeleteTransactionHistory(
    $input: DeleteTransactionHistoryInput!
    $condition: ModelTransactionHistoryConditionInput
  ) {
    deleteTransactionHistory(input: $input, condition: $condition) {
      id
      transaction {
        id
        userID
        type
        status
        currency
        sourceAccount {
          id
          createdAt
          updatedAt
        }
        targetAccount {
          id
          createdAt
          updatedAt
        }
        methodName
        methodTransactionID
        value
        createdAt
        updatedAt
        persisted
        history {
          nextToken
        }
      }
      createdAt
      status
      resourceType
      resourceID
      updatedAt
    }
  }
`;
export const createContactRequest = /* GraphQL */ `
  mutation CreateContactRequest(
    $input: CreateContactRequestInput!
    $condition: ModelContactRequestConditionInput
  ) {
    createContactRequest(input: $input, condition: $condition) {
      id
      userID
      firstName
      lastName
      phone
      email
      supportLanguage
      country
      preferences
      callMeASAP
      createdAt
      updatedAt
    }
  }
`;
export const updateContactRequest = /* GraphQL */ `
  mutation UpdateContactRequest(
    $input: UpdateContactRequestInput!
    $condition: ModelContactRequestConditionInput
  ) {
    updateContactRequest(input: $input, condition: $condition) {
      id
      userID
      firstName
      lastName
      phone
      email
      supportLanguage
      country
      preferences
      callMeASAP
      createdAt
      updatedAt
    }
  }
`;
export const deleteContactRequest = /* GraphQL */ `
  mutation DeleteContactRequest(
    $input: DeleteContactRequestInput!
    $condition: ModelContactRequestConditionInput
  ) {
    deleteContactRequest(input: $input, condition: $condition) {
      id
      userID
      firstName
      lastName
      phone
      email
      supportLanguage
      country
      preferences
      callMeASAP
      createdAt
      updatedAt
    }
  }
`;
